/**
 * 缓存说明:工单相关的组
 */
import vm from '@/cache/storeTools.js'
import messageApi from '@/components/api/order/messageApi.js'
var basestate = {
	messageData:{}
}
function getKey(pageData) {
	var Keys = Object.keys(pageData)
	var key = ''
	Keys.forEach((data,i)=>{
		if(i!=0){
			key+='_'
		}
		key+=pageData[data]
	})
	return key
}
var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		// searchMessage: (orderId, pageIndex, pageSize, bgTime, success, failure) => {
		searchMessage(state, getters) {
			return (orderId, pageIndex, pageSize, bgTime)=>{
				var pageData = {
					orderId, pageIndex, pageSize, bgTime
				}
				if (state.messageData[getKey(pageData)]  == undefined) {
					store.commit('searchMessage',pageData)
				}
				return state.messageData[getKey(pageData)]
			}
		},

	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		searchMessage(state,pageData) {
			messageApi.searchMessage(pageData.orderId, pageData.pageIndex, pageData.pageSize, pageData.bgTime,res => {
				vm.Vue.set(state.messageData, getKey(pageData), res)
			}, res => {
				log(res)
			})
		},
	}
})

//对外提供
export default store

/**
 * 需要分页的内容,以数组存储全部,取的时候进行分页,
 * 刷新时获取指定页数据,然后合并,重复的数据以新的为准,
 * 可能会导致缺失遗漏,但是有清理缓存就可以了
 */
